import { Any } from '@common/defs/types';

const prefix = '/aide';
const Routes: Any = {
  Prefix: prefix,
  WhatIsAlloClients: `${prefix}/cest-quoi-alloclients`,
  Faq: `${prefix}/faq`,
  ClosingScript: `${prefix}/script-appel-prospect`,
  News: `${prefix}/actualites`,
  LeModele: `${prefix}/le-modele-alloclients`,
};

export default Routes;
